// extracted by mini-css-extract-plugin
export default {"career":"eeJFuqjc3TXkIXBvZgmM","header":"VYDr6c6zSYWqqqnVKsDI","jobs":"Y0nsPNlTxs_Q9IdgTUZ1","job":"E5ppObReyDkEGKghjyVg","text":"jiCb3u1MsHHv2RIydXn2"};